// this is an autogenerated file from App/Account/Content/Settings/Content/CalendarSettings/Settings/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CalendarSettings_Settings_Content(
  $object: calendar_location_settings_insert_input!
  $columns_to_update: [calendar_location_settings_update_column!]!
) {
  insert_calendar_location_settings_one(
    object: $object
    on_conflict: {
      constraint: location_settings_location_id_key
      update_columns: $columns_to_update
    }
  ) {
    id
    location_id
    full_day_default
    patient_default
  }
}

`